import React from "react";

export default function Developer() {
  return (
    <div>
      <small>
        Developed with 💙 by{" "}
        <a
          href="https://www.dimaodin.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Dima Odintsov.
        </a>
      </small>
    </div>
  );
}
